// extracted by mini-css-extract-plugin
export default {"svgdiv":"lat_act_tbl_row_svgdiv__ri7DM","imgdiv":"lat_act_tbl_row_imgdiv__eZasZ"};